export default __webpack_public_path__ + "static/media/babySeat.237de83f.svg";